import React, { useState, useEffect } from "react";
import { StaticSelectInput } from "../../constant/SelectInput";
import { updateUserApi, getDivisionListApi } from "../../../services/UserService";
import { getLabelByValue, roleOptionsList } from "../../../utils";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const EditUser = () => {
    const navigate = useNavigate();
    const [isSubmitLoading, setIsSubmitLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const location = useLocation();
    const user = location.state?.user;
    const id = user.id;
    const documentPermission = { create: false, review: false, approve: false, issue: false }
    const testEvaluationPermission = { create: false, review: false, approve: false, issue: false }
    const auditPermission = { create: false, approve: false }

    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        password: "",
        phoneNumber: "",
        role: "",
        division: "",
        document_permission: documentPermission,
        audit_permission: auditPermission,
        test_evaluation_permission: testEvaluationPermission,
    });
    const [divisionOptions, setDivisionOptions] = useState([]);

    useEffect(() => {
        if (formData.role === "Auditor") {
            getDivisionListApi()
                .then((response) => {
                    setDivisionOptions(response.data.data);
                })
                .catch((error) => {
                    console.error("Failed to fetch divisions:", error);
                });
        }
    }, [formData.role]);




    useEffect(() => {
        if (user) {
            const formattedDivisions = user.auditor_profile?.assigned_divisions
                ? user.auditor_profile.assigned_divisions.map((division) => ({
                    value: division.id,
                    label: division.name,
                }))
                : [];
            // console.log("divi",formattedDivisions)
            setFormData({
                first_name: user.first_name || '',
                last_name: user.last_name || '',
                email: user.email || '',
                phone_number: user.phone_number || '',
                role: user.role || '',
                division: formattedDivisions,
                document_permission: user.document_permission || {},
                audit_permission: user.audit_permission || {},
                test_evaluation_permission: user.test_evaluation_permission || {},
            });
        }
    }, [location.state]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
        setFormData((prevData) => ({ ...prevData, [name]: value }));
    };

    const handleSelectChange = (name, value) => {
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handlePermissionChange = (permissionName, action, value) => {
        setFormData((prevData) => {
            const updatedSpecficPermissions = { ...prevData[permissionName] };
            updatedSpecficPermissions[action] = value
            return { ...prevData, [permissionName]: updatedSpecficPermissions };
        });
    };

    const handleSelectAllPermissionChange = (permissionName, value) => {
        setFormData((prevData) => {
            const newUpdatedPerm = {}
            Object.keys(prevData[permissionName]).forEach(key => {
                newUpdatedPerm[key] = value
            });
            return { ...prevData, [permissionName]: newUpdatedPerm };
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setIsSubmitLoading(true);
            const response = await updateUserApi(id, formData);
            toast.success(response.data.message);
            navigate(`/user/${id}`);
        } catch (error) {
            toast.error(error.response.data.message);
        }
        finally {
            setIsSubmitLoading(false);
        }
    };



    const handleCancel = () => {


        setFormData({
            firstName: "",
            lastName: "",
            email: "",
            password: "",
            phoneNumber: "",
            role: "",
            division: "",
            document_permission: documentPermission,
            audit_permission: auditPermission,
            test_evaluation_permission: testEvaluationPermission,
        });
        setErrors({});
        navigate(`/user/${id}`);
    };


    return (
        <div className="container-fluid">
            <div className="row px-sm-2 px-0">
                <div className="col-xl-12">
                    <div className="card px-sm-3 px-1">
                        <div className="card-body">
                            <h3 className="text-center mb-3">Edit User</h3>
                            <form>
                                <div className="row mb-2">
                                    {/* First Name */}
                                    <div className="col-md-6">
                                        <div className="form-group mb-3">
                                            <label className="form-label">
                                                First Name<span className="text-danger">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                name="first_name"
                                                className="form-control"
                                                placeholder="Enter First Name"
                                                value={formData.first_name}
                                                onChange={handleChange}
                                            />
                                            {errors.first_name && <div className="text-danger">{errors.first_name}</div>}
                                        </div>
                                    </div>

                                    {/* Last Name */}
                                    <div className="col-md-6">
                                        <div className="form-group mb-3">
                                            <label className="form-label">
                                                Last Name<span className="text-danger">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                name="last_name"
                                                className="form-control"
                                                placeholder="Enter Last Name"
                                                value={formData.last_name}
                                                onChange={handleChange}
                                            />
                                            {errors.last_name && <div className="text-danger">{errors.last_name}</div>}
                                        </div>
                                    </div>

                                    {/* Email */}
                                    <div className="col-md-6">
                                        <div className="form-group mb-3">
                                            <label className="form-label">
                                                Email<span className="text-danger">*</span>
                                            </label>
                                            <input
                                                type="email"
                                                name="email"
                                                placeholder="Enter Email"
                                                value={formData.email}
                                                onChange={handleChange}
                                                className="form-control"
                                            />
                                            {errors.email && <div className="text-danger">{errors.email}</div>}
                                        </div>
                                    </div>

                                    {/* Phone Number */}
                                    <div className="col-md-6">
                                        <div className="form-group mb-3">
                                            <label className="form-label">
                                                Phone Number<span className="text-danger">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                name="phone_number"
                                                placeholder="Enter Phone Number"
                                                value={formData.phone_number}
                                                onChange={handleChange}
                                                className="form-control"
                                            />
                                            {errors.phone_number && <div className="text-danger">{errors.phone_number}</div>}
                                        </div>
                                    </div>

                                    {/* Role Select */}
                                    <div className="col-md-6">
                                        <div className="form-group mb-3">
                                            <StaticSelectInput
                                                optionsList={roleOptionsList}
                                                setParentInputValue={handleSelectChange}
                                                name="role"
                                                value={formData.role}
                                                isClearable
                                                placeholder="Choose Role"
                                                label="Role"
                                                className="role-select"
                                                isRequired
                                                defaultValue={{
                                                    label: getLabelByValue(user.role, roleOptionsList),
                                                    value: user.role,
                                                }}
                                            />
                                            {errors.role && <div className="text-danger">{errors.role}</div>}
                                        </div>
                                    </div>
                                    {/* division */}
                                    {formData.role == "Auditor" && (
                                        <div className="col-md-6">
                                            <div className="form-group mb-3">
                                                <StaticSelectInput
                                                    optionsList={divisionOptions.map((division) => ({
                                                        value: division.id,
                                                        label: division.name
                                                    }))}
                                                    setParentInputValue={handleSelectChange}
                                                    name="division"
                                                    value={formData.division}
                                                    isClearable
                                                    is_multi={true}
                                                    placeholder="Choose Division"
                                                    label="Division"
                                                    className="role-select"
                                                    isRequired
                                                    defaultValue={formData.division}
                                                />
                                            </div>
                                        </div>
                                    )}
                                </div>



                                {/* Permissions Table */}
                                <div className="form-group">
                                    <label className="form-label">Permissions</label>
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Permission</th>
                                                <th>Create</th>
                                                <th>Review</th>
                                                <th>Approve</th>
                                                <th>Issue</th>
                                                <th>Select All</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Document Permission</td>
                                                {["create", "review", "approve", "issue"].map((action) => (
                                                    <td key={action}>
                                                        {Object.keys(documentPermission).includes(action) ?
                                                            <div className="form-check custom-checkbox">
                                                                <input
                                                                    type="checkbox"
                                                                    className="form-check-input"
                                                                    value={action}
                                                                    checked={formData.document_permission[action]}
                                                                    onChange={(e) =>
                                                                        handlePermissionChange("document_permission", action, e.target.checked)
                                                                    }
                                                                />
                                                            </div>
                                                            : null
                                                        }
                                                    </td>
                                                ))}
                                                <td>
                                                    <div className="form-check custom-checkbox">
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            checked={Object.values(formData["document_permission"]).every((val) => val)}
                                                            onChange={(e) =>
                                                                handleSelectAllPermissionChange("document_permission", e.target.checked)
                                                            }
                                                        />
                                                    </div>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>Audit Permission</td>
                                                {["create", "review", "approve", "issue"].map((action) => (
                                                    <td key={action}>
                                                        {Object.keys(auditPermission).includes(action) ?
                                                            <div className="form-check custom-checkbox">
                                                                <input
                                                                    type="checkbox"
                                                                    className="form-check-input"
                                                                    value={action}
                                                                    checked={formData.audit_permission[action]}
                                                                    onChange={(e) =>
                                                                        handlePermissionChange("audit_permission", action, e.target.checked)
                                                                    }
                                                                />
                                                            </div>
                                                            : null
                                                        }
                                                    </td>
                                                ))}
                                                <td>
                                                    <div className="form-check custom-checkbox">
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            checked={Object.values(formData["audit_permission"]).every((val) => val)}
                                                            onChange={(e) =>
                                                                handleSelectAllPermissionChange("audit_permission", e.target.checked)
                                                            }
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Test/Evaluation Permission</td>
                                                {["create", "review", "approve", "issue"].map((action) => (
                                                    <td key={action}>
                                                        {Object.keys(testEvaluationPermission).includes(action) ?
                                                            <div className="form-check custom-checkbox">
                                                                <input
                                                                    type="checkbox"
                                                                    className="form-check-input"
                                                                    value={action}
                                                                    checked={formData.test_evaluation_permission[action]}
                                                                    onChange={(e) =>
                                                                        handlePermissionChange("test_evaluation_permission", action, e.target.checked)
                                                                    }
                                                                />
                                                            </div>
                                                            : null
                                                        }
                                                    </td>
                                                ))}
                                                <td>
                                                    <div className="form-check custom-checkbox">
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            checked={Object.values(formData["test_evaluation_permission"]).every((val) => val)}
                                                            onChange={(e) =>
                                                                handleSelectAllPermissionChange("test_evaluation_permission", e.target.checked)
                                                            }
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                {/* Submit Button */}
                                <div className="d-flex align-items-center justify-content-center">
                                    <button
                                        type="button"
                                        onClick={handleSubmit}
                                        className="btn btn-primary me-3"
                                        disabled={isSubmitLoading}
                                    >
                                        {isSubmitLoading ? "Updating..." : "Update"}
                                    </button>

                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={handleCancel}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div >
        </div >
    );
};

export default EditUser;